class DoPostError extends Error {
  public response: Response
  public body: object
  public url: string

  constructor(response: Response, url?: string, body?: object) {
    super(`doPost failed: ${response.statusText}`)
    this.name = 'DoPostError'
    this.response = response
    this.url = url
    this.body = body
  }
}

export default DoPostError
